module.exports = "<span ng-hide=$ctrl.readOnlyMode><button class=\"btn btn-dark btn-sm\" ng-if=$ctrl.isItemCanBeAmended ng-click=$ctrl.checkJourneyChangeEligibility()><l10n>amend journey</l10n></button> <button class=\"btn btn-dark btn-sm\" ng-if=!$ctrl.isItemCanBeAmended ng-class=\"{disabled: !$ctrl.isItemCanBeAmended}\" uib-tooltip={{$ctrl.amendmentTooltipText}}><l10n>amend journey</l10n></button></span>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/trip-change-ticket/trip-change-ticket.html
// module id = 3388
// module chunks = 0